export default "__VITE_ASSET__mc7TnPkX__"